import { Theme } from '@mui/material/styles';

export function breadcrumbs(theme: Theme) {
  return {
    MuiBreadcrumbs: {
      styleOverrides: {
        root: {
          display: 'grid',
        },
        separator: {
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
        },
        ol: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flexWrap: 'nowrap',
        },
        li: {
          display: 'inline-flex',
          margin: theme.spacing(0.25, 0),
          overflow: 'hidden',
          '& > *': {
            ...theme.typography.body2,
          },
          '&:last-child': {
            overflow: 'unset',
          },
          '&:not(:last-child) > *': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        },
      },
    },
  };
}
